import * as React from 'react';
import PropTypes from 'prop-types';

import { Tile } from '../tile';

function RelatedHit({ hit }) {
  return (
    <Tile
      title={hit.title}
      slug={`/${hit.tags.includes('Mens') ? 'mens' : 'ladies'}/products/${
        hit.handle
      }`}
      price={Number(hit.price)}
      image={hit.image ? hit.image : ''}
      constantPrice={hit.variants_min_price === hit.variants_max_price}
      available={hit.inventory_available}
    />
  );
}

RelatedHit.propTypes = {
  hit: PropTypes.object.isRequired,
};

export { RelatedHit };
